import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import { ApiManagersInsightPostObjectivesEditType } from "~/domains";

type ParamsType = {
  id: string;
};

const request = async ({
  id,
}: ParamsType): Promise<ApiManagersInsightPostObjectivesEditType> => {
  const response =
    await new ApiClient().get<ApiManagersInsightPostObjectivesEditType>(
      `/api/managers/insight_post_objectives/${id}/edit`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersInsightPostObjectivesEdit = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApiManagersInsightPostObjectivesEditType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisManagersInsightPostObjectivesEdit", id],
    cacheTime: 0,
    queryFn: () => request({ id }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
